import React from 'react';
import { SkeletonLine } from 'src/components/Helpers/SkeletonLine';

import classes from './BlogPostsLoading.scss';

export const BlogPostsLoading: React.FC = React.memo(() => (
    <>
        {[...Array(2).keys()].map((key) => (
            <div className={classes.wrapper} key={key}>
                <SkeletonLine />
                <SkeletonLine />
                <SkeletonLine />
                <SkeletonLine />
            </div>
        ))}
    </>
));
